import React, { useState } from "react";
import styles from "./FieldPassword.module.css";

import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

function FieldPassword(props) {
  const [validationError, setValidationError] = useState(false);
  const [validationText, setValidationText] = useState("");

  const [values, setValues] = React.useState({
    amount: "",
    password: "",
    weight: "",
    weightRange: "",
    showPassword: false,
  });

  // const handleChange = (prop) => (event) => {
  //   setValues({ ...values, [prop]: event.target.value });
  // };

  const handleOnChange = (event) => {
    const value = event.target.value;

    // required field validation
    // if (props.required && value?.length > 0) {
    //   setValidationError(false);
    //   setValidationText("");
    // } else {
    //   setValidationError(true);
    //   setValidationText("Required");
    // }

    props.handleChange(value);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className={styles.PasswordFieldContainer}>
    <div className="TextField">
      <FormControl variant="outlined">
        <OutlinedInput
          placeholder={props.placeholder}
          id="outlined-adornment-password"
          type={values.showPassword ? "text" : "password"}
          error={props.error ? props.error : validationError}
          helperText={props.helperText}
          value={props.value}
          onChange={handleOnChange}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {values.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
          labelWidth={70}
        />
        <div className="FieldPasswordHelperText">
          {(props.validationError || props.error) && (
            <FormHelperText error>{props.helperText}</FormHelperText>
          )}
        </div>
      </FormControl>
    </div>
    </div>
  );
}

export default FieldPassword;
